var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServicesBranding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "486px",
    height: "486px",
    viewBox: "0 0 486 486",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "services-branding") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "services-branding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.804653862,0 C-0.00775643709,317.558841 -0.00775643709,476.338262 0.804653862,476.338262",
    id: "Path-6",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    fill: "#FFFFFF",
    opacity: 0.400000006,
    x: 18.8046539,
    y: 58.3232968,
    width: 104,
    height: 104,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    fill: "#AAD590",
    opacity: 0.200000003,
    x: 162.804654,
    y: 58.3232968,
    width: 288,
    height: 104,
    rx: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 39.3232968,
    x2: 472,
    y2: 39.3232968,
    id: "Path-7",
    stroke: "#FFFFFF",
    strokeDasharray: "2,4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 181.323297,
    x2: 472,
    y2: 181.323297,
    id: "Path-7-Copy",
    stroke: "#FFFFFF",
    strokeDasharray: "2,4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 265.323297,
    x2: 472,
    y2: 265.323297,
    id: "Path-7-Copy-2",
    stroke: "#FFFFFF",
    strokeDasharray: "2,4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.843826,21.3232968 C142.843826,140.030244 142.843826,199.028126 142.843826,198.316944",
    id: "Path-8",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 162.804654,
    y: 200.323297,
    width: 62,
    height: 11,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    fill: "#FFFFFF",
    x: 162.804654,
    y: 217.323297,
    width: 50,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-8",
    fill: "#FFFFFF",
    x: 162.804654,
    y: 224.323297,
    width: 45,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-9",
    fill: "#FFFFFF",
    x: 162.804654,
    y: 231.323297,
    width: 54,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-10",
    fill: "#FFFFFF",
    x: 162.804654,
    y: 238.323297,
    width: 24,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 365.804654,
    y: 200.323297,
    width: 62,
    height: 11,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    fill: "#FFFFFF",
    x: 365.804654,
    y: 217.323297,
    width: 50,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-8",
    fill: "#FFFFFF",
    x: 365.804654,
    y: 224.323297,
    width: 45,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-9",
    fill: "#FFFFFF",
    x: 365.804654,
    y: 231.323297,
    width: 54,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-10",
    fill: "#FFFFFF",
    x: 365.804654,
    y: 238.323297,
    width: 24,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#AAD590",
    cx: 31.8046539,
    cy: 302.323297,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9246539,303.243297 L58.3086539,303.243297 L58.7086539,301.579297 L60.2766539,301.579297 L60.6446539,299.995297 L59.0926539,299.995297 L59.6846539,297.499297 L57.8926539,297.499297 L57.2846539,299.995297 L55.6206539,299.995297 L56.2286539,297.499297 L54.4206539,297.499297 L53.8286539,299.995297 L52.1966539,299.995297 L51.8446539,301.579297 L53.4446539,301.579297 L53.0446539,303.243297 L51.4926539,303.243297 L51.1246539,304.827297 L52.6766539,304.827297 L52.0846539,307.323297 L53.8766539,307.323297 L54.4686539,304.827297 L56.1326539,304.827297 L55.5406539,307.323297 L57.3486539,307.323297 L57.9406539,304.827297 L59.5726539,304.827297 L59.9246539,303.243297 Z M55.2526539,301.579297 L56.9166539,301.579297 L56.5166539,303.243297 L54.8526539,303.243297 L55.2526539,301.579297 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    fill: "#FFFFFF",
    opacity: 0.5,
    x: 66.8046539,
    y: 300.323297,
    width: 50,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    opacity: 0.800000012,
    cx: 31.8046539,
    cy: 336.323297,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9246539,337.243297 L58.3086539,337.243297 L58.7086539,335.579297 L60.2766539,335.579297 L60.6446539,333.995297 L59.0926539,333.995297 L59.6846539,331.499297 L57.8926539,331.499297 L57.2846539,333.995297 L55.6206539,333.995297 L56.2286539,331.499297 L54.4206539,331.499297 L53.8286539,333.995297 L52.1966539,333.995297 L51.8446539,335.579297 L53.4446539,335.579297 L53.0446539,337.243297 L51.4926539,337.243297 L51.1246539,338.827297 L52.6766539,338.827297 L52.0846539,341.323297 L53.8766539,341.323297 L54.4686539,338.827297 L56.1326539,338.827297 L55.5406539,341.323297 L57.3486539,341.323297 L57.9406539,338.827297 L59.5726539,338.827297 L59.9246539,337.243297 Z M55.2526539,335.579297 L56.9166539,335.579297 L56.5166539,337.243297 L54.8526539,337.243297 L55.2526539,335.579297 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    fill: "#FFFFFF",
    opacity: 0.5,
    x: 66.8046539,
    y: 334.323297,
    width: 50,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    opacity: 0.600000024,
    cx: 31.8046539,
    cy: 370.323297,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9246539,371.243297 L58.3086539,371.243297 L58.7086539,369.579297 L60.2766539,369.579297 L60.6446539,367.995297 L59.0926539,367.995297 L59.6846539,365.499297 L57.8926539,365.499297 L57.2846539,367.995297 L55.6206539,367.995297 L56.2286539,365.499297 L54.4206539,365.499297 L53.8286539,367.995297 L52.1966539,367.995297 L51.8446539,369.579297 L53.4446539,369.579297 L53.0446539,371.243297 L51.4926539,371.243297 L51.1246539,372.827297 L52.6766539,372.827297 L52.0846539,375.323297 L53.8766539,375.323297 L54.4686539,372.827297 L56.1326539,372.827297 L55.5406539,375.323297 L57.3486539,375.323297 L57.9406539,372.827297 L59.5726539,372.827297 L59.9246539,371.243297 Z M55.2526539,369.579297 L56.9166539,369.579297 L56.5166539,371.243297 L54.8526539,371.243297 L55.2526539,369.579297 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    fill: "#FFFFFF",
    opacity: 0.5,
    x: 66.8046539,
    y: 368.323297,
    width: 50,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    opacity: 0.400000006,
    cx: 31.8046539,
    cy: 404.323297,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9246539,405.243297 L58.3086539,405.243297 L58.7086539,403.579297 L60.2766539,403.579297 L60.6446539,401.995297 L59.0926539,401.995297 L59.6846539,399.499297 L57.8926539,399.499297 L57.2846539,401.995297 L55.6206539,401.995297 L56.2286539,399.499297 L54.4206539,399.499297 L53.8286539,401.995297 L52.1966539,401.995297 L51.8446539,403.579297 L53.4446539,403.579297 L53.0446539,405.243297 L51.4926539,405.243297 L51.1246539,406.827297 L52.6766539,406.827297 L52.0846539,409.323297 L53.8766539,409.323297 L54.4686539,406.827297 L56.1326539,406.827297 L55.5406539,409.323297 L57.3486539,409.323297 L57.9406539,406.827297 L59.5726539,406.827297 L59.9246539,405.243297 Z M55.2526539,403.579297 L56.9166539,403.579297 L56.5166539,405.243297 L54.8526539,405.243297 L55.2526539,403.579297 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    fill: "#FFFFFF",
    opacity: 0.5,
    x: 66.8046539,
    y: 402.323297,
    width: 50,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    opacity: 0.200000003,
    cx: 31.8046539,
    cy: 438.323297,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9246539,439.243297 L58.3086539,439.243297 L58.7086539,437.579297 L60.2766539,437.579297 L60.6446539,435.995297 L59.0926539,435.995297 L59.6846539,433.499297 L57.8926539,433.499297 L57.2846539,435.995297 L55.6206539,435.995297 L56.2286539,433.499297 L54.4206539,433.499297 L53.8286539,435.995297 L52.1966539,435.995297 L51.8446539,437.579297 L53.4446539,437.579297 L53.0446539,439.243297 L51.4926539,439.243297 L51.1246539,440.827297 L52.6766539,440.827297 L52.0846539,443.323297 L53.8766539,443.323297 L54.4686539,440.827297 L56.1326539,440.827297 L55.5406539,443.323297 L57.3486539,443.323297 L57.9406539,440.827297 L59.5726539,440.827297 L59.9246539,439.243297 Z M55.2526539,437.579297 L56.9166539,437.579297 L56.5166539,439.243297 L54.8526539,439.243297 L55.2526539,437.579297 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    fill: "#FFFFFF",
    opacity: 0.5,
    x: 66.8046539,
    y: 436.323297,
    width: 50,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6446539,120.374409 C80.1997141,122.132315 93.2567385,128.781945 99.815727,140.323297 C109.65421,157.635325 112.838279,205.323297 154.729242,205.323297",
    id: "Path-9",
    stroke: "#AAD590",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.54869,169.608528 C305.408416,193.418374 323.801933,205.323297 351.729242,205.323297",
    id: "Path-9-Copy",
    stroke: "#AAD590",
    strokeWidth: 4,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesBranding);
export default __webpack_public_path__ + "static/media/services-branding.5c3408572cfdb1863ff5b2054760cd18.svg";
export { ForwardRef as ReactComponent };